import { environment } from '@/constants';

export const SUPPORTED_PREFILL_ROUTES = ['join', 'login'];

export default {
  methods: {
    findComponentInTree(name, current = this.$root) {
      if (current.$options && current.$options.name === name) return current;

      // Do a tree traversal to find the component by `name`.
      for (let child of current.$children) {
        let component = this.findComponentInTree(name, child);
        if (component) return component;
      }
    },

    prefillJoinComponent() {
      const email = `test_${Date.now()}@example.com`;
      const password = 'password';
      const component = this.findComponentInTree('Join');

      component.email = email;
      component.password = password;
      component.inviteCode = 'code';
    },

    prefillLoginComponent() {
      const component = this.findComponentInTree('Login');

      component.email = 'maros@example.com';
      component.password = 'password';
    },

    prefillForm() {
      if (environment === 'production') {
        return;
      }

      switch (this.$route.name) {
        case 'join':
          return this.prefillJoinComponent();
        case 'login':
          return this.prefillLoginComponent();
      }
    },

    handlePrefillFormKey(event) {
      if (event.key !== 'Shift') return;

      const diff = this.lastCall ? Date.now() - this.lastCall : null;
      this.lastCall = Date.now();

      if (diff && diff < 200) {
        return this.prefillForm();
      }
    },
  },
};
